import React from "react"
import { useSelector } from "react-redux"

import { ACTIVE, INACTIVE } from "const"
import { StoreType, UserFilters } from "client/store"
import { ActiveInactive } from "client/utils"
import {
    SearchBar,
    SearchFilter,
} from "client/components"

interface SearchUser {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: UserFilters
    onFilter: (filters: UserFilters) => void
}

const statusArray = [ACTIVE, INACTIVE]

const UserSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchUser) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const popupFilters: SearchFilter[] = []

    statusArray.forEach((status: ActiveInactive) => {
        popupFilters.push({
            title: lang[status],
            isActive: filters.status === status,
            onAdd: (obj: UserFilters) => ({
                ...obj,
                status,
            }),
            onClose: (obj: UserFilters) => ({
                ...obj,
                status: null,
            }),
        })
    })

    return (
        <SearchBar
            id={id}
            filters={filters}
            leftOffset={leftOffset}
            rightOffset={rightOffset}
            popupFilters={popupFilters}
            onFilter={onFilter}
        />
    )
}
export default UserSearch
